/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Error_Internal_Error13Inputs */

const en_us2_body_assessment_error_internal_error13 = /** @type {(inputs: Body_Assessment_Error_Internal_Error13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong during the calculation. Try again, and tell support if it keeps happening.`)
};

const pt_br2_body_assessment_error_internal_error13 = /** @type {(inputs: Body_Assessment_Error_Internal_Error13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo deu errado no cálculo. Tente de novo e, se continuar, fale com o suporte.`)
};

const es_419_body_assessment_error_internal_error13 = /** @type {(inputs: Body_Assessment_Error_Internal_Error13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal durante el cálculo. Inténtalo de nuevo y, si sigue pasando, avísale a soporte.`)
};

const pt_pt2_body_assessment_error_internal_error13 = /** @type {(inputs: Body_Assessment_Error_Internal_Error13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo correu mal no cálculo. Tenta de novo e, se continuar, contacta o suporte.`)
};

const fr_fr2_body_assessment_error_internal_error13 = /** @type {(inputs: Body_Assessment_Error_Internal_Error13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un problème est survenu pendant le calcul. Réessaie, et contacte le support si ça continue.`)
};

const de_de2_body_assessment_error_internal_error13 = /** @type {(inputs: Body_Assessment_Error_Internal_Error13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei der Berechnung ist etwas schiefgelaufen. Versuch es erneut und melde dich beim Support, wenn es wieder passiert.`)
};

const it_it2_body_assessment_error_internal_error13 = /** @type {(inputs: Body_Assessment_Error_Internal_Error13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualcosa è andato storto durante il calcolo. Riprova e, se continua, contatta l'assistenza.`)
};

/**
* | output |
* | --- |
* | "Something went wrong during the calculation. Try again, and tell support if it keeps happening." |
*
* @param {Body_Assessment_Error_Internal_Error13Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_error_internal_error13 = /** @type {((inputs?: Body_Assessment_Error_Internal_Error13Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Error_Internal_Error13Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_error_internal_error13(inputs)
	if (locale === "es-419") return es_419_body_assessment_error_internal_error13(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_error_internal_error13(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_error_internal_error13(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_error_internal_error13(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_error_internal_error13(inputs)
	return en_us2_body_assessment_error_internal_error13(inputs)
});
export { body_assessment_error_internal_error13 as "body-assessment.error.INTERNAL_ERROR" }